import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { FormControl, NgModel } from '@angular/forms';
import { InputContentDataType } from 'client/models';
import { createOptionGrouper } from 'common/helper';
import { FormStore } from '../../common/form.store';
import { AnswerTypeComponent } from '../answer-type.component';

@Component({
  selector: 'answer-select-with-text',
  templateUrl: './answer-select-with-text.component.html',
  standalone: false
})
export class AnswerSelectWithTextComponent extends AnswerTypeComponent implements OnInit, OnDestroy {
  @ViewChild('commentBox') commentBox: ElementRef;
  @ViewChild('selectWithTextModel') selectWithTextModel: NgModel;

  // Live grouping - the base swaps optionsObs when a webform rule returns its options, so a
  // one-shot ngOnInit grouping would render rule-populated dropdowns empty.
  public optionGroupsFor = createOptionGrouper<InputContentDataType>((o) => o.heading);
  public showComment = false;
  public dataStringValue;
  public dataStringExtraValue;

  private subs = new Subscription();

  ngOnInit() {
    super.ngOnInit();
    this.optionsObs = of(this.inputContent.inputContentDatas);

    const sub1 = FormStore.reset$.subscribe(() => {
      setTimeout(() => {
        this.dataStringValue = '';
        this.dataStringExtraValue = '';
        this.showComment = false;
        (this.formControlObj as FormControl).patchValue('');
      });
    });
    this.subs.add(sub1);

    const val = this.formControlObj.value;
    this.dataStringValue = val?.dataStringValue ?? '';
    this.dataStringExtraValue = val?.dataStringExtraValue ?? '';
    this.showComment = !!this.dataStringExtraValue;

    const sub2 = FormStore.touched$.subscribe(() => {
      if (this.formControlObj.touched) {
        this.markNgModelAsTouched();
      }
    });
    this.subs.add(sub2);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subs.unsubscribe();
  }

  public selectOption() {
    const optionControl = this.formControlObj as FormControl;
    optionControl.setValue({ dataStringValue: this.dataStringValue, dataStringExtraValue: this.dataStringExtraValue });
  }

  public toggleShowComment() {
    this.showComment = !this.showComment;

    if (this.showComment) {
      setTimeout(() => {
        this.commentBox?.nativeElement?.focus();
      }, 100);
    } else {
      this.dataStringExtraValue = '';
      this.selectOption();
      this.showComment = false
    }

  }

  private markNgModelAsTouched() {
    if (this.selectWithTextModel?.control && !this.selectWithTextModel?.control.touched) {
      this.selectWithTextModel.control.markAsTouched();
    }
  }
}